export const localizationTour = {
    module: 'localization',
    title: 'Localization Tour',
    title_vi: 'Tour Bản địa hoá',
    description: 'As the Enterprise DPO (P-VN-01), manage the regulatory framework lifecycle: install Vietnamese market packs, activate PDPL and Decree 13 frameworks, map requirements to platform modules, and manage translations.',
    description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Enterprise DPO (P-VN-01), manage the regulatory framework lifecycle: install Vietnamese market packs, activate PDPL and Decree 13 frameworks, map requirements to platform modules, and manage translations.',
    estimated_duration_seconds: 72,
    steps: [
        {
            step_id: 'loc_dashboard',
            navigate_to: '/admin/localization/dashboard',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Localization Dashboard',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Localization Dashboard',
            description: 'As the DPO, you monitor active market packs (Vietnam, EU), installed frameworks (PDPL, Decree 13, Decree 356), language coverage, and pending pack submissions from this dashboard.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the DPO, you monitor active market packs (Vietnam, EU), installed frameworks (PDPL, Decree 13, Decree 356), language coverage, and pending pack submissions from this dashboard.',
            position: 'bottom',
        },
        {
            step_id: 'loc_market_packs',
            navigate_to: '/admin/localization/market-packs',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Market Packs Catalog',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Market Packs Catalog',
            description: 'Install market packs that bundle jurisdiction-specific frameworks, official forms, and translations. The Vietnam pack includes PDPL, Decree 13, Decree 356, and all Phu luc/Mau so templates.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Install market packs that bundle jurisdiction-specific frameworks, official forms, and translations. The Vietnam pack includes PDPL, Decree 13, Decree 356, and all Phu luc/Mau so templates.',
            position: 'bottom',
        },
        {
            step_id: 'loc_language_packs',
            navigate_to: '/admin/localization/language-packs',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Language Packs',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Language Packs',
            description: 'Manage installed language packs. Vietnamese language support is required for PDPL compliance, ensuring data subjects receive notices and forms in their language.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Manage installed language packs. Vietnamese language support is required for PDPL compliance, ensuring data subjects receive notices and forms in their language.',
            position: 'bottom',
        },
        {
            step_id: 'loc_install_lang',
            target: '.dm-header .btn-primary',
            title: 'Install a Language Pack',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Install a Language Pack',
            description: 'Install additional language packs to support multi-language compliance operations and data subject communications.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Install additional language packs to support multi-language compliance operations and data subject communications.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 300,
        },
        {
            step_id: 'loc_install_modal',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Available Language Packs',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Available Language Packs',
            description: 'Browse available packs and install those required for your operational jurisdictions. Each pack provides translations for all platform modules.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Browse available packs and install those required for your operational jurisdictions. Each pack provides translations for all platform modules.',
            position: 'right',
        },
        {
            step_id: 'loc_frameworks',
            navigate_to: '/admin/localization/frameworks',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Regulatory Frameworks',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Regulatory Frameworks',
            description: 'Browse all installed frameworks (PDPL, Decree 13, Decree 356) with their controls, requirements, and effective dates. The Watchlist tab tracks draft Vietnamese regulations for proactive compliance planning.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Browse all installed frameworks (PDPL, Decree 13, Decree 356) with their controls, requirements, and effective dates. The Watchlist tab tracks draft Vietnamese regulations for proactive compliance planning.',
            position: 'bottom',
        },
        {
            step_id: 'loc_framework_table',
            target: '.dm-table',
            title: 'Framework List',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Framework List',
            description: 'Each framework shows its code, jurisdiction, issuing authority (e.g., Ministry of Public Security), and activation status. Expand parent frameworks to see sub-frameworks like individual Decree chapters.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Each framework shows its code, jurisdiction, issuing authority (e.g., Ministry of Public Security), and activation status. Expand parent frameworks to see sub-frameworks like individual Decree chapters.',
            position: 'bottom',
        },
        {
            step_id: 'loc_framework_requirements',
            target: '.dm-table tbody tr:first-child',
            title: 'View Requirements',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: View Requirements',
            description: 'Open the full control list for any framework. PDPL requirements map to specific platform modules, driving which compliance actions appear in each area.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Open the full control list for any framework. PDPL requirements map to specific platform modules, driving which compliance actions appear in each area.',
            position: 'bottom',
            action: {
                type: 'click',
                target: '.dm-table tbody tr:first-child td:last-child button:first-child',
            },
            duration_ms: 300,
        },
        {
            step_id: 'loc_framework_requirements_modal',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Requirements',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Requirements',
            description: 'Requirements grouped by category. As the DPO, review these controls to understand which PDPL obligations are mapped to each platform module.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Requirements grouped by category. As the DPO, review these controls to understand which PDPL obligations are mapped to each platform module.',
            position: 'right',
        },
        {
            step_id: 'loc_submissions',
            navigate_to: '/admin/localization/submissions',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Pack Submissions',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Pack Submissions',
            description: 'Review and approve new market or language pack submissions. Each submission undergoes validation to ensure regulatory accuracy before activation.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Review and approve new market or language pack submissions. Each submission undergoes validation to ensure regulatory accuracy before activation.',
            position: 'bottom',
        },
        {
            step_id: 'loc_submit_pack',
            target: '.dm-header .btn-primary',
            title: 'Submit a New Pack',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Submit a New Pack',
            description: 'Submit a new regulatory framework or language pack for DPO review and validation before deployment.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Submit a new regulatory framework or language pack for DPO review and validation before deployment.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 300,
        },
        {
            step_id: 'loc_submit_form',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Pack Submission Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Pack Submission Form',
            description: 'Specify the pack type, market code (e.g., VN for Vietnam), and version. The pack undergoes structural validation before entering the review queue.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Specify the pack type, market code (e.g., VN for Vietnam), and version. The pack undergoes structural validation before entering the review queue.',
            position: 'right',
        },
        {
            step_id: 'loc_mappings',
            navigate_to: '/admin/localization/mappings',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Module Mappings',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Module Mappings',
            description: 'Map PDPL and Decree requirements to platform modules. These mappings determine which compliance controls, forms, and guidance appear in each module.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Map PDPL and Decree requirements to platform modules. These mappings determine which compliance controls, forms, and guidance appear in each module.',
            position: 'bottom',
        },
        {
            step_id: 'loc_create_mapping',
            target: '.dm-header .btn-primary',
            title: 'Create a Mapping',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Create a Mapping',
            description: 'Link a specific framework requirement to its corresponding platform module for contextual compliance guidance.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Link a specific framework requirement to its corresponding platform module for contextual compliance guidance.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 300,
        },
        {
            step_id: 'loc_mapping_form',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Module Mapping Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Module Mapping Form',
            description: 'Link a framework requirement (e.g., PDPL Article 9 consent obligations) to a platform module (e.g., Consent). Conflict resolution handles overlapping requirements from multiple frameworks.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Link a framework requirement (e.g., PDPL Article 9 consent obligations) to a platform module (e.g., Consent). Conflict resolution handles overlapping requirements from multiple frameworks.',
            position: 'right',
        },
        {
            step_id: 'loc_translations',
            navigate_to: '/admin/localization/translations',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Translation Preview',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Translation Preview',
            description: 'Compare source and target locale translations side by side. Ensure Vietnamese translations are complete so data subjects receive PDPL notices in their language.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Compare source and target locale translations side by side. Ensure Vietnamese translations are complete so data subjects receive PDPL notices in their language.',
            position: 'bottom',
        },
        {
            step_id: 'loc_audit',
            navigate_to: '/admin/localization/audit',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Localization Audit',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Localization Audit',
            description: 'Immutable audit log of all localization changes: framework activations, pack installs, mapping updates. This trail proves when and by whom regulatory framework configurations were modified.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Immutable audit log of all localization changes: framework activations, pack installs, mapping updates. This trail proves when and by whom regulatory framework configurations were modified.',
            position: 'bottom',
        },
        {
            step_id: 'loc_complete',
            target: '.dm-page',
            title: 'Localization Tour Complete',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Localization Tour Complete',
            description: 'You can now manage the full framework lifecycle: market pack installation, PDPL/Decree framework activation, requirement-to-module mapping, translation management, and audit-grade change tracking.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: You can now manage the full framework lifecycle: market pack installation, PDPL/Decree framework activation, requirement-to-module mapping, translation management, and audit-grade change tracking.',
            position: 'bottom',
        },
    ],
};
//# sourceMappingURL=localization.js.map